import styles from '../MobileCard.module.scss';

import { EntryStatus } from 'chaika-frontend-types/frontend-cms';

import { EntryStatusItem } from '@common/EntryStatusItem';

export function StatusIcon(entryStatus: EntryStatus, isSignedWithEDS?: boolean): React.ReactElement<any> {
    return (
        <div className={styles.status}>
            <EntryStatusItem
                status={entryStatus}
                isSignedWithEDS={isSignedWithEDS}
            />
        </div>
    );
}
